import React, { FC } from 'react';
import styled from 'styled-components';

// Shown in place of the slot rail when a you-pick / build-your-own package has
// nothing the customer can pick.
//
// Two ways to get here, and neither is something the customer did wrong:
//   * the price list links no active child products to the package at all
//     (CompanyPricingModelProduct#childless_slot_bundle?), or
//   * international shipping restrictions filtered every child out for this
//     parent.
//
// Either way the rail renders empty, and before ENG-1683 the package was sold
// that way — it reached the lab with nothing in it. Now addToCart refuses it,
// so without this the customer sees an empty screen and then an alert telling
// them to choose items that are not there.
const Container = styled.div`
  padding: 32px 16px;
  text-align: center;
`;

const Title = styled.h4`
  margin-bottom: 8px;
`;

const Message = styled.p`
  color: #666;
  margin: 0;
`;

const PackageUnavailable: FC = () => (
  <Container>
    <Title>Product not available</Title>
    <Message>
      This package can&rsquo;t be ordered right now. Please choose a different
      product, or contact us if you need help.
    </Message>
  </Container>
);

export default PackageUnavailable;
